export default "__VITE_ASSET__01c53968__"